import React from 'react';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

/**
 * Loading Spinner Component
 * Reusable loading indicator for async operations
 */
const LoadingSpinner = React.memo(({
  size = 'medium',
  message = 'Loading...',
  fullScreen = false,
  className = ''
}) => {
  const sizeClass = `spinner-${size}`;
  const containerClass = fullScreen ? 'spinner-container-fullscreen' : 'spinner-container';

  return (
    <div className={`${containerClass} ${className}`}>
      <div className={`spinner ${sizeClass}`}>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
});

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
  className: PropTypes.string,
};

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
